import React from 'react';
import PropTypes from 'prop-types';
import s from './PersonaliseWidget.scss';

const PersonaliseWidget = props => {
  const {
    card,
    heading,
    section,
    subsection,
    msid,
    template,
    contentprimestatus,
    userprimestatus,
    styleObj,
    isWapView,
    classname,
    disableWidget,
    dataset,
    ga4Type,
  } = props;

  if (disableWidget) {
    return null;
  }

  return (
    <div
      className={`persObserver personaliseWidgetLoader_${msid} ${s.shimmer} ${
        !isWapView ? s.web : s.mweb
      } ${s[classname]}`}
      data-card={card}
      data-heading={heading}
      data-section={section}
      data-subsection={subsection}
      id={`${card}_${msid}`}
      data-msid={msid}
      data-template={template}
      data-contentprimestatus={contentprimestatus}
      data-userprimestatus={userprimestatus}
      style={styleObj}
      data-ga4type={ga4Type}
      dangerouslySetInnerHTML={{ __html: '' }}
      {...dataset}
    />
  );
};

PersonaliseWidget.propTypes = {
  card: PropTypes.string,
  section: PropTypes.string,
  subsection: PropTypes.string,
  msid: PropTypes.string,
  template: PropTypes.string,
  contentprimestatus: PropTypes.string,
  userprimestatus: PropTypes.string,
  styleObj: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  classname: PropTypes.string,
  disableWidget: PropTypes.bool,
  heading: PropTypes.string,
  dataset: PropTypes.shape({}),
  heading: PropTypes.string,
  ga4Type: PropTypes.string,
};

PersonaliseWidget.defaultProps = {
  card: '',
  section: '',
  subsection: '',
  msid: '',
  template: '',
  contentprimestatus: '',
  userprimestatus: '',
  styleObj: {},
  isWapView: false,
  classname: '',
  disableWidget: false,
  heading: '',
  dataset: {},
  heading: '',
  ga4Type: '',
};

export default PersonaliseWidget;
